(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["car-giveaway-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function bind(el) {
      if (el.dataset.cglBound === '1') return;
      var raw = el.getAttribute('data-cgl-countdown');
      if (!raw) return;
      var end = Date.parse(raw);
      if (isNaN(end)) return;
      el.dataset.cglBound = '1';
      var d = el.querySelector('[data-cgl-d]');
      var h = el.querySelector('[data-cgl-h]');
      var m = el.querySelector('[data-cgl-m]');
      var s = el.querySelector('[data-cgl-s]');
      var timer;
      function tick() {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
        if (diff <= 0 && timer) clearInterval(timer);
      }
      tick();
      timer = setInterval(tick, 1000);
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-cgl-countdown]').forEach(bind);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgl-header-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof window === 'undefined' || !document.body) return;
    var threshold = 40;
    function update() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > threshold) document.body.classList.add('is-scrolled');
      else document.body.classList.remove('is-scrolled');
    }
    var ticking = false;
    function onScroll() { if (!ticking) { window.requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  (function () { 'use strict';
    var FIRE = '🔥';
    function parsePriceText(s) { if (!s) return null; var cleaned = s.replace(/[^\d.,]/g, ''); if (!cleaned) return null; var lastComma = cleaned.lastIndexOf(','); var lastDot = cleaned.lastIndexOf('.'); var v; if (lastComma > lastDot) v = parseFloat(cleaned.replace(/\./g, '').replace(',', '.')); else v = parseFloat(cleaned.replace(/,/g, '')); if (isNaN(v)) return null; return Math.round(v * 100); }
    function fmt(n) { try { return n.toLocaleString('en-US'); } catch (e) { return String(n); } }
    /* v47: 300X pill. entries = current price * 300 (cents * 3). Always two-tone with glowing 300X. */
    function buildPill(cents, lg, homeOnly) {
      var pill = document.createElement('div');
      var cls = lg ? 'jep-pill jep-pill--lg' : 'jep-pill';
      pill.className = cls;
      pill.setAttribute('data-jep-pill', '1');
      var entries = Math.floor(cents * 3);
      pill.innerHTML = '<span class="jep-pill__entries">' + fmt(entries) + ' ENTRIES</span><span class="jep-pill__mult jep-pill__mult--glow">300X</span>';
      return pill;
    }
    function isCatalogPage() {
      var main = document.getElementById('MainContent');
      var tpl = main ? (main.getAttribute('data-template') || '') : '';
      if (tpl.indexOf('collection') !== -1 || tpl.indexOf('search') !== -1 || tpl.indexOf('list-collections') !== -1) return true;
      try {
        var path = (location && location.pathname) ? location.pathname : '';
        if (path.indexOf('/collections/') === 0 || path.indexOf('/collections') === 0 || path.indexOf('/search') === 0) {
          if (path.indexOf('/products/') === -1) return true;
        }
      } catch (e) {}
      return false;
    }
    function isHomePage() {
      var main = document.getElementById('MainContent');
      if (!main) return false;
      var t = main.getAttribute('data-template') || '';
      return t === 'index' || t === 'home';
    }
    function isProductPage() {
      var main = document.getElementById('MainContent');
      if (!main) return false;
      var t = main.getAttribute('data-template') || '';
      return t.indexOf('product') !== -1;
    }
    function hideFireText(scope) {
      var root = scope || document.getElementById('MainContent') || document.body;
      if (!root) return;
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.children.length > 0) continue;
        if (el.classList && el.classList.contains('jep-pill')) continue;
        if (el.closest && el.closest('.jep-pill')) continue;
        var txt = (el.textContent || '');
        if (txt.indexOf(FIRE) !== -1 && /entries?/i.test(txt)) {
          el.classList.add('jep-hide');
        }
      }
    }
    /* v42: HOME_CONFIGS marked with home:true so JS builds single-red homepage pill */
    var HOME_CONFIGS = [
      { card: '.jas-pcard', priceSel: '.jas-pcard__price', titleSel: '.jas-pcard__title', home: true },
      { card: '.jbs__card', priceSel: '.jbs__price', titleSel: '.jbs__title', home: true },
      { card: '.jds__card', priceSel: '.jds__price', titleSel: '.jds__title', home: true },
      { card: '.cgl-card', priceSel: '.cgl-card__price', titleSel: '.cgl-card__title', home: true }
    ];
    var NATIVE_CONFIGS = [
      { card: 'product-card', priceSel: '.price, price-block, .price__regular .price-item, .price-item--regular, [class*="price"]', titleSel: 'product-title-block, .product-title, [class*="product-title"], h3, h2, h4' },
      { card: '.product-card', priceSel: '.price, price-block, [class*="price"]', titleSel: 'product-title-block, .product-title, [class*="product-title"], h3, h2, h4' },
      { card: '[data-product-card]', priceSel: '[class*="price"]', titleSel: '[class*="title"], h3, h2, h4' }
    ];
    var RECO_CONTAINER_SEL = [
      'product-recommendations',
      'recommended-products',
      'related-products',
      'complementary-products',
      '[class*="product-recommendations"]',
      '[class*="recommended-products"]',
      '[class*="related-products"]',
      '[class*="related_products"]',
      '[class*="recommendation"]',
      '[class*="you-may-also-like"]',
      '[class*="you_may_also_like"]',
      '[class*="complementary"]',
      'section[id*="recommendations"]',
      'section[id*="related"]',
      '[data-section-type*="recommendation"]',
      '[data-section-type*="related"]'
    ].join(', ');
    function processCard(card, cfg) {
      hideFireText(card);
      if (card.getAttribute('data-jep-bound') === '1') return;
      if (card.querySelector(':scope > [data-jep-pill], :scope > * > [data-jep-pill], :scope [data-jep-pill]')) { card.setAttribute('data-jep-bound', '1'); return; }
      var priceEl = card.querySelector(cfg.priceSel); if (!priceEl) return;
      var cents = parsePriceText(priceEl.textContent); if (!cents || cents <= 0) return;
      var title = card.querySelector(cfg.titleSel); if (!title) return;
      card.setAttribute('data-jep-bound', '1');
      /* v42: pass home flag to buildPill (true for homepage cards, false otherwise) */
      var pill = buildPill(cents, false, cfg.home === true);
      title.parentNode.insertBefore(pill, title);
    }
    function processProductPage() {
      var main = document.getElementById('MainContent');
      if (!main) return;
      var tpl = main.getAttribute('data-template') || '';
      if (tpl.indexOf('product') === -1) return;
      if (main.getAttribute('data-jep-product-bound') === '1') return;
      var h1 = main.querySelector('h1');
      if (!h1) return;
      var section = h1.closest('.shopify-section, section, product-information, main') || main;
      var priceEl = section.querySelector('price-block, .product-price__price, .price__regular .price-item, .price-item--regular, .price');
      if (!priceEl) priceEl = main.querySelector('price-block, .product-price__price, .price__regular .price-item, .price-item--regular');
      if (!priceEl) return;
      var cents = parsePriceText(priceEl.textContent);
      if (!cents || cents <= 0) return;
      if (section.querySelector('[data-jep-pill]')) { main.setAttribute('data-jep-product-bound', '1'); return; }
      /* Product page pill keeps the OLD two-tone format (entries + 100X) — not a homepage card */
      var pill = buildPill(cents, true, true);
      h1.parentNode.insertBefore(pill, h1.nextSibling);
      main.setAttribute('data-jep-product-bound', '1');
      hideFireText(section);
    }
    function processRecommendations(doc) {
      try {
        doc.querySelectorAll(RECO_CONTAINER_SEL).forEach(function (container) {
          NATIVE_CONFIGS.forEach(function (cfg) {
            try {
              container.querySelectorAll(cfg.card).forEach(function (card) { processCard(card, cfg); });
            } catch (e) {}
          });
          try { hideFireText(container); } catch (e) {}
        });
      } catch (e) {}
    }
    function processAll(root) {
      var doc = root || document;
      HOME_CONFIGS.forEach(function (cfg) {
        try { doc.querySelectorAll(cfg.card).forEach(function (card) { processCard(card, cfg); }); } catch (e) {}
      });
      if (isCatalogPage()) {
        NATIVE_CONFIGS.forEach(function (cfg) {
          try { doc.querySelectorAll(cfg.card).forEach(function (card) { processCard(card, cfg); }); } catch (e) {}
        });
        try { hideFireText(document.getElementById('MainContent') || document.body); } catch (e) {}
      }
      try { processProductPage(); } catch (e) {}
      processRecommendations(doc);
      if (isProductPage()) {
        NATIVE_CONFIGS.forEach(function (cfg) {
          try {
            doc.querySelectorAll(cfg.card).forEach(function (card) {
              if (card.closest('product-information, .product-information, .product__info')) return;
              processCard(card, cfg);
            });
          } catch (e) {}
        });
        try { hideFireText(document.getElementById('MainContent') || document.body); } catch (e) {}
      }
      if (isHomePage()) { try { hideFireText(document.getElementById('MainContent') || document.body); } catch (e) {} }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { processAll(); });
    else processAll();
    document.addEventListener('shopify:section:load', function (e) { processAll(e.target); });
    document.addEventListener('shopify:block:select', function () { processAll(); });
    setTimeout(processAll, 500);
    setTimeout(processAll, 1500);
    setTimeout(processAll, 3000);
    setTimeout(processAll, 5000);
    setTimeout(processAll, 8000);
    setTimeout(processAll, 12000);
    if ('MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function (muts) {
        var has = false;
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length > 0) { has = true; break; } }
        if (!has || pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; processAll(); });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  (function () {
    if (typeof window === 'undefined' || !document.body) return;
    function isHome() {
      var main = document.getElementById('MainContent');
      var t = main && main.getAttribute('data-template');
      return t === 'index' || t === 'home';
    }
    function killBottomSpace() {
      if (isHome()) {
        document.documentElement.style.setProperty('background', '#000', 'important');
        document.body.style.setProperty('background', '#000', 'important');
      } else {
        document.documentElement.style.removeProperty('background');
        document.body.style.removeProperty('background');
      }
      document.body.style.setProperty('padding-bottom', '0', 'important');
      document.body.style.setProperty('margin-bottom', '0', 'important');
      var mainEl = document.querySelector('main');
      if (mainEl) { mainEl.style.setProperty('padding-bottom', '0', 'important'); mainEl.style.setProperty('margin-bottom', '0', 'important'); }
      var lastMain = document.querySelector('main > .shopify-section:last-child');
      if (lastMain) { lastMain.style.setProperty('padding-bottom', '0', 'important'); lastMain.style.setProperty('margin-bottom', '0', 'important'); }
      var footers = document.querySelectorAll('#shopify-section-footer, [id*="shopify-section-footer"], .shopify-section-group-footer-group, footer.section-wrapper, footer');
      footers.forEach(function (f) { f.style.setProperty('padding-bottom', '0', 'important'); f.style.setProperty('margin-bottom', '0', 'important'); });
      var innerFooterSections = document.querySelectorAll('.shopify-section-group-footer-group .section, footer > .section, footer .section-content-wrapper, footer .layout-panel-flex');
      innerFooterSections.forEach(function (el) { el.style.setProperty('padding-bottom', '0', 'important'); el.style.setProperty('margin-bottom', '0', 'important'); });
    }
    function apply() {
      if (isHome()) document.body.classList.add('jas-home'); else document.body.classList.remove('jas-home');
      killBottomSpace();
      if (window.innerWidth > 749) return;
      var grids = document.querySelectorAll('.jas-quick-entries .jas-product-grid, .jas-quick-entries .jas-product-grid--scroll');
      grids.forEach(function (grid) {
        grid.style.setProperty('display', 'grid', 'important');
        grid.style.setProperty('grid-template-columns', 'none', 'important');
        grid.style.setProperty('grid-template-rows', 'none', 'important');
        grid.style.setProperty('grid-auto-flow', 'column', 'important');
        grid.style.setProperty('grid-auto-columns', '72%', 'important');
        grid.style.setProperty('overflow-x', 'auto', 'important');
        grid.style.setProperty('overflow-y', 'hidden', 'important');
        grid.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
        grid.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
        grid.style.setProperty('gap', '12px', 'important');
        grid.style.setProperty('padding-bottom', '0', 'important');
      });
      var cards = document.querySelectorAll('.jas-quick-entries .jas-pcard');
      cards.forEach(function (card) {
        card.style.setProperty('scroll-snap-align', 'start', 'important');
        card.style.setProperty('width', '100%', 'important');
        card.style.setProperty('min-width', '0', 'important');
      });
      var qe = document.querySelectorAll('.jas-quick-entries');
      qe.forEach(function (el) {
        el.style.setProperty('padding-top', '10px', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
        el.style.setProperty('margin', '0', 'important');
        var section = el.closest('.shopify-section');
        if (section) { section.style.setProperty('padding', '0', 'important'); section.style.setProperty('margin', '0', 'important'); }
        var cta = el.querySelector('.jas-section-cta');
        if (cta) cta.style.setProperty('display', 'none', 'important');
      });
      var ft = document.querySelectorAll('.jas-featured');
      ft.forEach(function (el) {
        el.style.setProperty('padding-top', '28px', 'important');
        el.style.setProperty('margin-top', '0', 'important');
        var section = el.closest('.shopify-section');
        if (section) { section.style.setProperty('padding-top', '0', 'important'); section.style.setProperty('margin-top', '0', 'important'); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
    document.addEventListener('shopify:section:load', apply);
    window.addEventListener('resize', apply);
    setTimeout(apply, 500);
    setTimeout(apply, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jas-car-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCarousel(section) {
    var track = section.querySelector('[data-jas-track]');
    var slides = section.querySelectorAll('.jas-car-feature__slide');
    var prevBtn = section.querySelector('[data-jas-prev]');
    var nextBtn = section.querySelector('[data-jas-next]');
    var dots = section.querySelectorAll('[data-jas-dot]');

    if (!track || slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var perView = window.innerWidth > 768 ? 3 : 1;
    var maxIndex = Math.max(0, total - perView);

    function go(index) {
      current = Math.max(0, Math.min(index, maxIndex));
      var pct = (100 / total) * current;
      track.style.transform = 'translateX(-' + pct + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-jas-dot')));
      });
    });

    // Auto-advance every 4s
    var timer = setInterval(function () {
      go(current >= maxIndex ? 0 : current + 1);
    }, 4000);

    section.addEventListener('mouseenter', function () { clearInterval(timer); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.jas-car-feature').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jas-car-showcase"] && !Shopify.designMode) return;
  try {
    
(function () { 'use strict';
  function initShowcase(section) {
    var track = section.querySelector('[data-jcs-track]');
    var slides = section.querySelectorAll('[data-jcs-slide]');
    var prevBtn = section.querySelector('[data-jcs-prev]');
    var nextBtn = section.querySelector('[data-jcs-next]');
    var dotBtns = section.querySelectorAll('[data-jcs-dot]');
    var total = slides.length;
    if (!track || total < 1) return;
    var current = 0;
    var isMobile = window.innerWidth <= 768;
    var isDragging = false; var startX = 0; var dragDelta = 0;
    function setActive(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('jcs__slide--active', i === idx); });
      dotBtns.forEach(function (d, i) { d.classList.toggle('jcs__dot--active', i === idx); });
    }
    function go(idx) {
      if (isMobile) return;
      idx = ((idx % total) + total) % total;
      current = idx;
      var slideW = track.parentElement.offsetWidth / 3;
      var offset = (current * slideW) - slideW;
      offset = Math.max(0, Math.min(offset, (total - 3) * slideW));
      track.style.transform = 'translateX(-' + offset + 'px)';
      setActive(current);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    dotBtns.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-jcs-dot'), 10)); }); });
    track.addEventListener('mousedown', function (e) { if (isMobile) return; isDragging = true; startX = e.clientX; dragDelta = 0; track.style.transition = 'none'; });
    window.addEventListener('mousemove', function (e) { if (!isDragging) return; dragDelta = e.clientX - startX; });
    window.addEventListener('mouseup', function () { if (!isDragging) return; isDragging = false; track.style.transition = ''; if (dragDelta < -60) go(current + 1); else if (dragDelta > 60) go(current - 1); else go(current); });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.from(slides).indexOf(entry.target);
            if (idx !== -1) { current = idx; setActive(idx); }
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { observer.observe(s); });
    }
    var autoTimer;
    function startAuto() { if (isMobile) return; autoTimer = setInterval(function () { go(current + 1); }, 4200); }
    function stopAuto() { clearInterval(autoTimer); }
    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);
    window.addEventListener('resize', function () { isMobile = window.innerWidth <= 768; if (!isMobile) go(current); });
    setActive(0); startAuto();
  }
  function initAll(root) { (root || document).querySelectorAll('.jcs').forEach(initShowcase); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jas-hero-giveaway"] && !Shopify.designMode) return;
  try {
    
(function () { 'use strict';
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function bindTimer(el) {
    if (el._jasBound) return;
    el._jasBound = true;
    var raw = el.getAttribute('data-cgl-countdown');
    if (!raw) return;
    var end = Date.parse(raw);
    if (isNaN(end)) return;
    var dEl = el.querySelector('[data-cgl-d]');
    var hEl = el.querySelector('[data-cgl-h]');
    var mEl = el.querySelector('[data-cgl-m]');
    var sEl = el.querySelector('[data-cgl-s]');
    function tick() {
      var diff = end - Date.now();
      if (diff < 0) diff = 0;
      if (dEl) dEl.textContent = pad(Math.floor(diff / 86400000));
      if (hEl) hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (mEl) mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (sEl) sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      if (diff > 0) setTimeout(tick, 1000);
    }
    tick();
  }
  function initAll(root) { (root || document).querySelectorAll('[data-cgl-countdown]').forEach(bindTimer); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jas-winner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function initSlider(section) {
    var slider = section.querySelector('.jw__slider');
    if (!slider || slider._jwBound) return;
    slider._jwBound = true;
    var track   = slider.querySelector('[data-jw-track]');
    var slides  = slider.querySelectorAll('[data-jw-slide]');
    var prevBtn = slider.querySelector('[data-jw-prev]');
    var nextBtn = slider.querySelector('[data-jw-next]');
    var dotBtns = slider.querySelectorAll('[data-jw-dot]');
    var total   = slides.length;
    if (!track || total < 1) return;
    var current = 0;
    var isMobile = window.innerWidth <= 900;
    var isDragging = false; var startX = 0; var dragDelta = 0;
    function setActive(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('jw__slide--active', i === idx); });
      dotBtns.forEach(function (d, i) { d.classList.toggle('jw__dot--active', i === idx); });
    }
    function go(idx) {
      if (isMobile) return;
      idx = ((idx % total) + total) % total;
      current = idx;
      var slideW = track.parentElement.offsetWidth / 3;
      var offset = (current * slideW) - slideW;
      if (total <= 3) offset = 0;
      else offset = Math.max(0, Math.min(offset, (total - 3) * slideW));
      track.style.transform = 'translateX(-' + offset + 'px)';
      setActive(current);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    dotBtns.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-jw-dot'), 10)); });
    });
    track.addEventListener('mousedown', function (e) {
      if (isMobile) return;
      isDragging = true; startX = e.clientX; dragDelta = 0;
      track.style.transition = 'none';
    });
    window.addEventListener('mousemove', function (e) { if (!isDragging) return; dragDelta = e.clientX - startX; });
    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';
      if (dragDelta < -60) go(current + 1);
      else if (dragDelta > 60) go(current - 1);
      else go(current);
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.from(slides).indexOf(entry.target);
            if (idx !== -1) { current = idx; setActive(idx); }
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { observer.observe(s); });
    }
    var autoTimer;
    function startAuto() { if (isMobile) return; if (total <= 1) return; autoTimer = setInterval(function () { go(current + 1); }, 4500); }
    function stopAuto() { clearInterval(autoTimer); }
    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);
    window.addEventListener('resize', function () { isMobile = window.innerWidth <= 900; if (!isMobile) go(current); });
    setActive(0);
    startAuto();
  }
  function initAll(root) { (root || document).querySelectorAll('.jas-winner').forEach(initSlider); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
